/**
 * Video Room Route - Gutachter View
 * /video/:appointmentId
 *
 * Kept intentionally small so heavy LiveKit/UI dependencies are code-split and
 * only loaded when this route is visited.
 */

import { createFileRoute } from "@tanstack/react-router";
import { Suspense, lazy } from "react";

const LazyGutachterVideoRoom = lazy(() =>
  import("../../components/video/GutachterVideoRoom").catch(() => {
    // Chunk missing after deploy — reload once to get fresh index.html
    const key = "chunk-reload:/video";
    if (!sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, "1");
      window.location.reload();
    }
    // Throw so React still shows the error boundary if reload didn't help
    throw new Error("Video room chunk unavailable — page will reload");
  })
);

export const Route = createFileRoute("/_videoAuth/video/$appointmentId")({
  component: VideoRoomRoute,
});

function VideoRoomRoute() {
  const { appointmentId } = Route.useParams();
  return (
    <Suspense fallback={<div className="p-8">Lade Videoraum …</div>}>
      <LazyGutachterVideoRoom appointmentId={appointmentId} />
    </Suspense>
  );
}

